export default { sha: '540c0f69f31d49b692a13566e94404c222242d27', buildNumber: 'undefined' }
